import { NavigationHubDashboardTile } from './_components/NavigationHubDashboardTile.client'
import { NavigationHubFavoritesTile } from './_components/NavigationHubFavoritesTile.client'
import { NavigationHubOrdersTile } from './_components/NavigationHubOrdersTile.client'
import { NavigationHubQuickOrderTile } from './_components/NavigationHubQuickOrderTile.client'
import { NavigationHubQuotesTile } from './_components/NavigationHubQuotesTile.client'

export function NavigationHub() {
  return (
    <div className="flex flex-wrap gap-1">
      <NavigationHubDashboardTile />
      <NavigationHubOrdersTile />
      <NavigationHubFavoritesTile />
      <NavigationHubQuotesTile />
      <NavigationHubQuickOrderTile />
    </div>
  )
}
